import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then(m => m.HomeComponent),
    title: 'Home'
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.LoginComponent),
    title: 'Login'
  },
  {
    path: 'oauth/callback',
    loadComponent: () => import('./pages/oauth-callback/oauth-callback').then(m => m.OAuthCallbackComponent),
    title: 'OAuth Callback'
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    children : [
      {
        path: 'complete-profile',
        loadComponent: () => import('./pages/onboarding/complete-profile/complete-profile').then(m => m.CompleteProfileComponent),
        title: 'Complete Profile'
      },
      {
        path: 'google-ads-account-selection',
        loadComponent: () => import('./pages/onboarding/google-ads-account-selection/google-ads-account-selection').then(m => m.GoogleAdsAccountSelectionComponent),
        title: 'Google Ads Account Selection'
      },
    ]
  },
  {
    path: 'account',
    canActivate: [authGuard],
    children: [
      {
        path: 'manage',
        loadComponent: () => import('./pages/profile/manage-profile/manage-profile').then(m => m.ManageProfileComponent),
        title: 'Manage Profile'
      }
    ]
  },
  {
    path: 'reports',
    canActivate: [authGuard],
    children : [
      {
        path: 'request',
        loadComponent: () => import('./pages/reports/report-request/report-request').then(m => m.ReportRequestComponent),
        title: 'Report Request'
      },
      {
        path: 'results',
        loadComponent: () => import('./pages/reports/report-results/report-results').then(m => m.ReportResultsComponent),
        title: 'Report Results'
      },
    ]
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact').then(m => m.ContactComponent),
    title: 'Contact Us'
  },
  {
    path: 'info',
    children: [
      {
        path: 'faq',
        loadComponent: () => import('./pages/info/faq/faq').then(m => m.FaqComponent),
        title: 'FAQ'
      },
      {
        path: 'performance-protection',
        loadComponent: () => import('./pages/info/performance-protection-long/performance-protection-long').then(m => m.PerformanceProtectionLongComponent),
        title: 'Performance Protection | Dream Agility'
      },
      {
        path: 'performance-protection-short',
        loadComponent: () => import('./pages/info/performance-protection-short/performance-protection-short').then(m => m.PerformanceProtectionShortComponent),
        title: 'Performance Protection | Dream Agility'
      }
    ]
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/company/privacy-policy/privacy-policy').then(m => m.PrivacyPolicy),
    title: 'Privacy Policy'
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./pages/company/terms-and-conditions/terms-and-conditions').then(m => m.TermsAndConditions),
    title: 'Terms & Conditions'
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/error-pages/forbidden/forbidden').then(m => m.ForbiddenComponent),
    title: 'Access Forbidden'
  },
  {
    path: '**',
    loadComponent: () => import('./pages/error-pages/not-found/not-found').then(m => m.NotFoundComponent),
    title: 'Page Not Found'
  }
];
